import MutationObserverInjector from "@ui-utils/Injector/MutationObserverInjector";
import { parseStringDataAttr } from "@ui-utils/Injector/utils";

import { LoggerInterface } from "@interfaces/LoggerInterface";

import DesignFeedProductWidget from "./DesignFeedProductWidget";

const TAGS_DATA_ATTR = "tags";

class DesignFeedProductWidgetInjector {
    constructor(
        private readonly placeholderSelector: string,
        private readonly logger: LoggerInterface,
        private readonly moi: MutationObserverInjector
    ) {}

    start() {
        this.logger.debug(`${DesignFeedProductWidgetInjector.name}.start`, {
            placeholderSelector: this.placeholderSelector,
        });

        const targets$ = this.moi.register({
            targetSelector: this.placeholderSelector,
        });

        targets$.subscribe((placeholder) => {
            this.logger.debug(
                `${DesignFeedProductWidgetInjector.name} found placeholder`,
                placeholder
            );

            const dataTags = parseStringDataAttr(placeholder, TAGS_DATA_ATTR);
            const tags = dataTags?.split(",")?.map((tag) => ({
                name: tag.replace("series: ", "#"),
                value: tag,
            }));

            const widget = new DesignFeedProductWidget(
                {
                    tags: tags || [],
                    target: placeholder,
                },
                this.logger
            );

            void widget.init();
        });
    }
}

export default DesignFeedProductWidgetInjector;
